import SlideTimeline from './player-slide-timeline';


export default class MainSeqTimeline extends SlideTimeline {}
